import React from 'react';

const TableHeader = () => {
  /* flex-basis matches column weight; min-w-0 + shrink lets row fit ~100% zoom main column; mins only where content needs it */
  const cell = 'px-1.5 sm:px-2 py-2.5 sm:py-3 text-xs sm:text-sm font-semibold text-white text-center leading-tight whitespace-normal break-words';
  return (
    <div className="flex w-full min-w-0">
      <div
        style={{ display: 'none' }}
        className={`flex-[10] basis-0 min-w-0 shrink ${cell} bg-cyan-800 rounded-tl-xl flex items-center justify-center`}
      >
        {/* intentionally blank — Enter Data */}
      </div>

      {/* Crew Timesheet — uses Enter Data column width while that button is hidden */}
      <div className={`flex-[14] basis-0 min-w-0 shrink ${cell} bg-cyan-800 rounded-tl-xl flex items-center justify-center`}>
        {/* intentionally blank — Crew Timesheet */}
      </div>

      <div className={`flex-[12.5] basis-0 min-w-0 shrink ${cell} bg-cyan-800 flex items-center justify-center`}>
        {/* intentionally blank — Tracking Details */}
      </div>

      <div className={`flex-[20] basis-0 min-w-0 shrink ${cell} bg-cyan-800 flex items-center justify-center`}>
        Activity
      </div>

      <div className={`flex-[10] basis-0 min-w-0 shrink ${cell} bg-indigo-600 flex items-center justify-center`}>
        Production Tracking
      </div>

      <div className={`flex-[7.5] basis-0 min-w-0 shrink ${cell} bg-amber-500 flex items-center justify-center`}>
        Labor Tracking
      </div>

      <div className={`flex-[7.5] basis-0 min-w-0 shrink ${cell} bg-cyan-600 flex items-center justify-center`}>
        Days Used / Est Day
      </div>

      <div className={`flex-[10] basis-0 min-w-0 shrink ${cell} bg-stone-500 flex items-center justify-center`}>
        Est. Crew Size
      </div>

      <div className={`flex-[10] basis-0 min-w-0 shrink ${cell} bg-stone-500 flex items-center justify-center`}>
        Est. Prod/Day
      </div>

      <div className={`flex-[12.5] basis-0 min-w-0 shrink ${cell} bg-stone-500 flex items-center justify-center`}>
        Est. Rental Equipment
      </div>

      <div className={`flex-[12.5] basis-0 min-w-0 shrink ${cell} bg-stone-500 rounded-tr-xl flex items-center justify-center`}>
        Est. Rental Days
      </div>
    </div>
  );
};

export default TableHeader;
